import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ConversationStep } from "../../interfaces";
import { ChatState } from "./types";

import { v4 } from "uuid";
import { livechatEnabledApps } from "../../util";

const initialState: ChatState = {
    isEstablishingConnection: false,
    isConnected: false,
    connectionId: "",
    chatId: "",
    messages: [],
    mode: "bot",
    chatHasBeenEscalated: false,
    chatHasBeenEnded: false,
    lastMessage: {},
    isLivechatEnabled: true,
};

const chatSlice = createSlice({
    name: "chat",
    initialState,
    reducers: {
        setChatHasBeenEscalated: (state, action) => {
            state.chatHasBeenEscalated = action.payload;
        },
        startConnecting: (state) => {
            state.isEstablishingConnection = true;
            state.chatId = v4();
        },
        connectionEstablished: (state) => {
            state.isConnected = true;
            state.isEstablishingConnection = true;
        },
        setIsLivechatEnabled: (state, action: PayloadAction<{ apiKey: string }>) => {
            state.isLivechatEnabled = livechatEnabledApps.includes(action.payload.apiKey);
        },
        setConnectionId: (state, action: PayloadAction<{ connectionId: string }>) => {
            state.connectionId = action.payload.connectionId;
        },
        resumeBotConversation: (state) => {
            state.chatHasBeenEnded = true;
            state.messages.push(state.lastMessage);
        },
        receiveMessage: (state, action: PayloadAction<{ message: any }>) => {
            const previousStep = state?.messages[state?.messages?.length - 1];
            state.mode = action?.payload?.message?.mode || "bot";

            if (action?.payload?.message?.status) {
                state.messages.push({
                    ...action?.payload?.message,
                    input: {
                        type: "text",
                    },
                    theme: previousStep?.theme,
                });
            } else {
                state.messages.push({
                    ...action?.payload?.message,
                    input: {
                        type: "text",
                    },
                    theme: previousStep?.theme,
                });
            }
            //if expert ended conversation
            if (state.mode === "bot") {
                state.chatHasBeenEscalated = false;
                state.chatHasBeenEnded = true;
                state.messages.push({
                    id: "great-speaking",
                    type: "bot",
                    escalated: false,
                    message:
                        "Great speaking today. I've now closed this chat. Let me know how we did!",
                    trigger: "Rating",
                });
            }
        },
        sendToCMS: (state, action: PayloadAction<{ message: ConversationStep }>) => {
            // state.messages.push(action.payload.message);
            return;
        },
        addMessage: (state, action: PayloadAction<{ message: ConversationStep }>) => {
            state.messages.push({
                ...action.payload.message,
                ...(state.mode === "human" && {
                    input: {
                        type: "text",
                        placeholder: "",
                    },
                }),
            });

            if (
                !action.payload.message.escalated &&
                action.payload.message.message !== "Let's Chat Now"
            ) {
                state.lastMessage = action.payload.message;
            }
        },
    },
});

export const chatActions = chatSlice.actions;

export default chatSlice;
